import { type DataTypeProvider } from "@devexpress/dx-react-grid";
import { formatting } from "@north-beam/nb-common";

export const Decimal = ({
  column,
  row,
}: DataTypeProvider.ValueFormatterProps) => {
  return (
    <div className="px-2 flex justify-end items-center w-full h-full">
      {formatting.formatDecimal(row[column.name], {
        precision: "approximate",
      })}
    </div>
  );
};
